import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SystemIcon } from '@volvo/vcdk-react';

export const PageNotFound: FunctionComponent = () => {
  const { t } = useTranslation('errorPages');

  return (
    <div className="error-page-container">
      <div className="icon-container">
        <SystemIcon size={72} icon="warning" filled={true} />
      </div>
      <h2>{t('404')}</h2>
    </div>
  );
};
